import { MarketProgram } from '@/features/bidding/constants'

export function useCountryBidExportMarketProgramMap() {
  return {
    ee: [],
    es: [],
    dk: [],
    nl: [],
    fi: [MarketProgram.FCRD_UP, MarketProgram.FCRD_DOWN, MarketProgram.FCRN, MarketProgram.FFR_UP],
    gr: [],
    no: [],
    se: [],
  }
}
